(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = "#loading-overlay {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  z-index: 2000;\n}";
  const fileName = "LoadingOverlay_LoadingOverlay_f589d605-8d11-4c30-8c8a-6a7efbc355c6";
  const element = document.querySelector("style[data-sass-component='LoadingOverlay_LoadingOverlay_f589d605-8d11-4c30-8c8a-6a7efbc355c6']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
import { LoadingSpinner } from "../LoadingSpinner/LoadingSpinner";
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingOverlay = () => {
  return /*#__PURE__*/_jsx("div", {
    id: "loading-overlay",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {})
  });
};
export { LoadingOverlay };